import React, { useEffect, useState } from 'react';
import { Typography, Autocomplete, TextField, IconButton } from '@mui/material';
import { Box } from '@mui/system';
import SettingsIcon from '@mui/icons-material/Settings';
import Grid from '@mui/material/Grid';
import { API, graphqlOperation } from 'aws-amplify';
import ToolTipComponent from './ToolTipComponent';
import LabelIcon from './LabelIcon';
import { listGeneralSetting } from '../../../graphql';
import { useListGeneralSettingQuery, useListVoucherSerialNumbersQuery } from '../../../redux/apis/newVoucherSettings.api';
import NewVoucherSettingsModal from '../Modals/newVoucherSettingModal';
import { useSelector } from 'react-redux';
import { useStateList } from './HandleInvoiceStateProvider';
import { CheckVoucherValid } from './CheckVoucherValid';
import { useTaxabilityOptions } from './UseTaxabilityOptions';
import Popper from "@mui/material/Popper";
import { styled } from "@mui/material/styles";

const CustomPopper = styled((props) => (
  <Popper
    {...props}
    placement="bottom-start"   // ✅ Force left alignment with the input
    modifiers={[
      { name: "flip", enabled: false },
      { name: "preventOverflow", enabled: false },
    ]}
  />
))({
  width: "auto !important",          // ✅ Content width
  minWidth: "fit-content !important",
  maxWidth: "none !important",
});

function VoucherComponent({
  data,
  invoiceLabels,
  voucherArr,
  params,
  setData,
  setInitialState,
  Type,

  invoiceEntry,
  setBackdropOpen,
  next,
}) {
  const {
      allTaxabilityOptions
    } = useTaxabilityOptions();
  const [serialNos, setSerialNos] = useState([]);
  const [openSettingsModal, setOpenSettingsModal] = useState();
  // const [listData, setListData] = useState([])
  const { partyType, activeVouchers, setActiveVouchers, setGeneralSettingsFlag, generalSettingsFlag } = useStateList();
  const {
    data: voucherList,
    isLoading: isVoucherListLoading,
    isError: isVoucherListError,
    // refetch
  } = useListVoucherSerialNumbersQuery({
    entrytypecd: invoiceLabels.voucherType,
  });
  const userPreferece = useSelector((state) => state.userPrefrenceandReducer);
        const { data: generalSettings } = useListGeneralSettingQuery(
          {
            entrytypecd: invoiceLabels.voucherType,
            financialyearid: userPreferece?.financialYear?.financialyearid,
          },
          {
            refetchOnMountOrArgChange: true,
          }
        );
         const voucherFlag = generalSettings?.find((item) => item.expiredtimestamp === 0)?.nextinvoicenumber;
  const getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  const companyType = getCompany?.relatedcompanydetailsnew?.[0].registrationtype;
  const handleVoucherChange = function (event, newValue) {
    let voucherNo = '';

    if (newValue?.value !== '') {
      activeVouchers?.forEach((ele) => {
        if (ele.serialnumber === newValue.value) {
          voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
        }
      });
      if(Type==="Sales" || Type==="Pos"){
      handleTaxabilityByVoucher(newValue?.serialflag);
      }
      setData((prev) => ({
        ...prev,
        seriesVouchers: newValue,
        voucherNumber: voucherNo,
      }));
    }
  };
 const handleTaxabilityByVoucher = (value) => {
  
  const allowed = [2, 3, 5, 7, 9];
  const flag = value === 1;
  const currentVal = data?.taxability?.value;


  if (flag) {
    if (!allowed.includes(currentVal)) {
      setData((prev) => ({
        ...prev,
        taxability: { label: "", value: "" },
        errorStatus: { ...prev.errorStatus, taxability: false },
        errorFields: { ...prev.errorFields, taxability: "" },
      }));
    }
  } 
  else {
    if (allowed.includes(currentVal)) {
      setData((prev) => ({
        ...prev,
        taxability: { label: "", value: "" },
        errorStatus: { ...prev.errorStatus, taxability: false },
        errorFields: { ...prev.errorFields, taxability: "" },
      }));
    }
  }
};

  const handleVoucherKeyDown = function (event) {
    const warMsg = '';
    const name = 'voucherNumber';
    const currentId = 'voucher';
    const nextId = next;
    const prevID = Type === 'Pos' ? 'partyName' : companyType == 3 ? 'partyName' : 'placeOfSupply';
    const required = true;

    handleAutoCompleteKeyDown(event, setData, name, currentId, nextId, required, warMsg, prevID);
  };
  const handleVoucherInputChange = function (event) {
    const { value } = event.target;

    if (value === '') {
      setData((prev) => ({
        ...prev,
        voucherNumber: value,
        errorStatus: {
          ...prev.errorStatus,
          voucherNumber: true,
        },
        errorFields: {
          ...prev.errorFields,
          voucherNumber: `${invoiceLabels?.voucherName} is required`,
        },
      }));
      return;
    }
    const { valid, message } = CheckVoucherValid(value, invoiceLabels?.voucherName);
    if (!valid) {
      setData((prev) => ({
        ...prev,
        voucherNumber: value,
        errorStatus: {
          ...prev.errorStatus,
          voucherNumber: true,
        },
        errorFields: {
          ...prev.errorFields,
          voucherNumber: message,
        },
      }));
      return;
    }

    let isValid = true;
    voucherArr?.forEach((ele) => {
      if (ele.VoucherNumber !== invoiceEntry?.InvoiceNumber && ele.VoucherNumber === value) {
        isValid = false;
      }
    });

    setData((prev) => ({
      ...prev,
      voucherNumber: value,
      errorStatus: {
        ...prev.errorStatus,
        voucherNumber: !isValid,
      },
      errorFields: {
        ...prev.errorFields,
        voucherNumber: isValid ? '' : `${invoiceLabels?.voucherName} already exists`,
      },
    }));
  };
  const handleVoucherInputKeyDown = function (event) {
    const { valid } = CheckVoucherValid(data?.voucherNumber, invoiceLabels?.voucherName);
    const warMsg = `${invoiceLabels.voucherName} is required`;
    const name = 'voucherNumber';
    const currentId = 'voucher';
    const nextId = !valid ? (Type === 'Pos' ? 'partyName' : 'placeOfSupply') : 'currency';
    const prevID = Type === 'Pos' ? 'partyName' : 'placeOfSupply';
    const required = true;

    handleTextKeyDown(event, setData, name, currentId, nextId, required, warMsg, prevID);
  };

  // async function getGeneralSettings(invoiceEntry) {
  //   try {
  //     let serialNoArr = [];
  //     let voucherNo = '';

  //     let nextInvNo = '';
  //     let serialNo = { label: '', value: '' };
  //     const resSerialVouchers = await API.graphql(
  //       graphqlOperation(listGeneralSetting, {
  //         entrytypecd: invoiceLabels.voucherType,
  //         financialyearid: getCompany.financialyearid,
  //       })
  //     );
  //     if (resSerialVouchers?.data?.listGeneralSetting?.length > 0) {
  //       let settingsArr = resSerialVouchers.data?.listGeneralSetting?.map((ele) => {
  //         if (ele.expiredtimestamp == 0) {
  //           nextInvNo = ele.nextinvoicenumber;
  //           return ele;
  //         }
  //       });
  //       setGeneralSettingsFlag(nextInvNo);
  //       if (nextInvNo !== -1) {
  //         let activeVouchers = resSerialVouchers.data?.listGeneralSetting?.filter((voucher) => voucher.serialisactive == 1);

  //         setActiveVouchers(activeVouchers);
  //         activeVouchers.map((ele) => {
  //           serialNoArr?.push({
  //             label: ele.prefix + ele.nextinvoicenumber + ele.suffix,
  //             value: ele.serialnumber,
  //           });
  //           if (
  //             (data?.taxability?.value == 2 || data?.taxability?.value == 3 || data?.taxability?.value == 5) &&
  //             !params?.id &&
  //             (Type === 'Sales' || Type === 'Pos')
  //           ) {
  //             if (ele.serialflag === 1) {
  //               voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
  //               serialNo = {
  //                 label: voucherNo,
  //                 value: ele.serialnumber,
  //               };
  //             }
  //           } else {
  //             if (ele.serialnumber === serialNoArr?.[0]?.value) {
  //               voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
  //               serialNo = {
  //                 label: serialNoArr?.[0]?.label,
  //                 value: serialNoArr?.[0]?.value,
  //               };
  //             }
  //           }
  //         });
  //         setSerialNos(serialNoArr);
  //         if (!params?.id && invoiceEntry.length == 0) {
  //           setGeneralSettingsFlag(nextInvNo);
  //           setData((prev) => ({
  //             ...prev,
  //             voucherNumber: voucherNo,
  //             seriesVouchers: serialNo,
  //           }));
  //           setInitialState((prev) => ({
  //             ...prev,
  //             voucherNumber: voucherNo,
  //             seriesVouchers: serialNo,
  //           }));
  //         } else {

  //           if (Type === 'Sales' || Type === 'Pos') {
  //             serialNoArr.map((ele) => {
  //             if (ele.label === invoiceEntry?.invoicenumber) {
  //               serialNo = { label: ele.label, value: ele.value };
  //             }
  //           });
  //             setData((prev) => ({
  //               ...prev,
  //               voucherNumber: invoiceEntry?.invoicenumber,
  //               seriesVouchers: serialNo,
  //             }));
  //             if (setInitialState) {
  //               setInitialState((prev) => ({
  //                 ...prev,
  //                 voucherNumber: invoiceEntry?.invoicenumber,
  //                 seriesVouchers: serialNo,
  //               }));
  //             }
  //           }
  //           if (Type === 'Purchase') {
  //               serialNoArr.map((ele) => {
  //             if (ele.label === invoiceEntry?.vouchernumber) {
  //               serialNo = { label: ele.label, value: ele.value };
  //             }
  //           });
  //             setData((prev) => ({
  //               ...prev,
  //               voucherNumber: invoiceEntry?.vouchernumber,
  //               seriesVouchers: serialNo,
  //             }));
  //             if (setInitialState)
  //               setInitialState((prev) => ({
  //                 ...prev,
  //                 voucherNumber: invoiceEntry?.vouchernumber,
  //                 seriesVouchers: serialNo,
  //               }));
  //           }
  //           if (Type === 'DebitNote' || Type === 'CreditNote') {
  //              serialNoArr.map((ele) => {
  //             if (ele.label === invoiceEntry?.crdrnotenumber) {
  //               serialNo = { label: ele.label, value: ele.value };
  //             }
  //           });
  //             setData((prev) => ({
  //               ...prev,
  //               voucherNumber: invoiceEntry?.crdrnotenumber,
  //               seriesVouchers: serialNo,
  //             }));
  //             if (setInitialState) {
  //               setInitialState((prev) => ({
  //                 ...prev,
  //                 voucherNumber: invoiceEntry?.crdrnotenumber,
  //                 seriesVouchers: serialNo,
  //               }));
  //             }
  //           }
  //         }
  //       } else {
  //         if (!params?.id && invoiceEntry.length == 0) {
  //           setData((prev) => ({
  //             ...prev,
  //             voucherNumber: '',
  //             seriesVouchers: {
  //               label: '',
  //               value: '',
  //             },
  //           }));
  //           setInitialState((prev) => ({
  //             ...prev,
  //             voucherNumber: '',
  //             seriesVouchers: {
  //               label: '',
  //               value: '',
  //             },
  //           }));
  //         }
  //       }
  //     }
  //     console.log("serialNo",serialNo);

  //   } catch (error) {
  //     setBackdropOpen(false);
  //     console.log('error', error);
  //   }
  // }
  //  async function getGeneralSettings(invoiceEntry) {
  //   try {
  //     const res = await API.graphql(
  //       graphqlOperation(listGeneralSetting, {
  //         entrytypecd: invoiceLabels.voucherType,
  //         financialyearid: getCompany.financialyearid,
  //       })
  //     );

  //     const rows = (res && res.data && res.data.listGeneralSetting) || [];
  //     if (!rows.length) {
  //       if (!params?.id && (!invoiceEntry || invoiceEntry.length === 0)) {
  //         const emptySerial = { label: "", value: "" };
  //         setData((p) => ({ ...p, voucherNumber: "", seriesVouchers: emptySerial }));
  //         if (typeof setInitialState === "function") {
  //           setInitialState((p) => ({ ...p, voucherNumber: "", seriesVouchers: emptySerial }));
  //         }
  //       }
  //       return;
  //     }

  //     const validRows = rows.filter((r) => r && r.expiredtimestamp === 0);
  //     const activeVouchers = validRows.filter((r) => r && r.serialisactive === 1);

  //     const nextInvNo = (validRows[0] && validRows[0].nextinvoicenumber) ?? -1;
  //     setGeneralSettingsFlag(nextInvNo);

  //     if (nextInvNo === -1 || String(nextInvNo) === "-1") {
  //       if (!params?.id && (!invoiceEntry || invoiceEntry.length === 0)) {
  //         const emptySerial = { label: "", value: "" };
  //         setData((p) => ({ ...p, voucherNumber: "", seriesVouchers: emptySerial }));
  //         if (typeof setInitialState === "function") {
  //           setInitialState((p) => ({ ...p, voucherNumber: "", seriesVouchers: emptySerial }));
  //         }
  //       }
  //       return;
  //     }

  //     const toLabel = (v) =>
  //       `${v?.prefix ?? ""}${v?.nextinvoicenumber ?? ""}${v?.suffix ?? ""}`;

  //     // Options from ACTIVE vouchers (labels preview latest numbers)
  //     let serialNoArr = activeVouchers.map((v) => ({
  //       label: toLabel(v),
  //       value: v?.serialnumber,
  //     }));

  //     setActiveVouchers(activeVouchers);
  //     setSerialNos(serialNoArr);

  //     const isSalesOrPos = Type === "Sales" || Type === "Pos";
  //     const isPurchase = Type === "Purchase";
  //     const isCrDr = Type === "DebitNote" || Type === "CreditNote";
  //     const isNew = !params?.id && (!invoiceEntry || invoiceEntry.length === 0);

  //     let voucherNumber = "";
  //     let selectedOption = { label: "", value: "" };

  //     if (isNew) {
  //       // NEW: choose default
  //       const taxVal = Number(data?.taxability?.value);
  //       const preferByFlag = isSalesOrPos && [2, 3, 5].includes(taxVal);
  //       const pick =
  //         (preferByFlag && activeVouchers.find((v) => v?.serialflag === 1)) ||
  //         activeVouchers[0];

  //       if (pick) {
  //         voucherNumber = toLabel(pick);
  //         selectedOption = { label: voucherNumber, value: pick.serialnumber };
  //       }
  //     } else {
  //       // EDIT: select SAVED series and show SAVED printed number
  //       const savedPrinted =
  //         (isSalesOrPos && invoiceEntry?.invoicenumber) ||
  //         (isPurchase && invoiceEntry?.vouchernumber) ||
  //         (isCrDr && invoiceEntry?.crdrnotenumber) ||
  //         "";

  //       const savedSerialNumber =
  //         invoiceEntry?.serialnumber ||
  //         invoiceEntry?.seriesvouchers?.value ||
  //         invoiceEntry?.seriesVouchers?.value ||
  //         null;

  //       // 1) Try exact serialnumber match
  //       let matchedVoucher =
  //         (savedSerialNumber &&
  //           activeVouchers.find(
  //             (v) => String(v.serialnumber) === String(savedSerialNumber)
  //           )) || null;

  //       // 2) Else try prefix/suffix match against printed number
  //       if (!matchedVoucher && savedPrinted) {
  //         const t = String(savedPrinted).trim();
  //         matchedVoucher =
  //           activeVouchers.find((v) => {
  //             const pref = String(v?.prefix ?? "");
  //             const suff = String(v?.suffix ?? "");
  //             return t.startsWith(pref) && t.endsWith(suff);
  //           }) || null;
  //       }

  //       // 3) If still not found, keep empty selection but keep printed number
  //       if (!matchedVoucher) {
  //         voucherNumber = savedPrinted || "";
  //         setSerialNos(serialNoArr);
  //         setData((prev) => ({
  //           ...prev,
  //           voucherNumber,
  //           seriesVouchers: selectedOption,
  //         }));
  //         if (typeof setInitialState === "function") {
  //           setInitialState((prev) => ({
  //             ...prev,
  //             voucherNumber,
  //             seriesVouchers: selectedOption,
  //           }));
  //         }
  //         return;
  //       }

  //       // Patch the matched option's label to the SAVED printed number
  //       voucherNumber = savedPrinted || toLabel(matchedVoucher);
  //       serialNoArr = serialNoArr.map((o) =>
  //         String(o.value) === String(matchedVoucher.serialnumber)
  //           ? { ...o, label: voucherNumber }
  //           : o
  //       );

  //       selectedOption =
  //         serialNoArr.find(
  //           (o) => String(o.value) === String(matchedVoucher.serialnumber)
  //         ) || { label: voucherNumber, value: matchedVoucher.serialnumber };
  //     }

  //     setSerialNos(serialNoArr);
  //     setData((prev) => ({
  //       ...prev,
  //       voucherNumber,
  //       seriesVouchers: selectedOption,
  //     }));
  //     if (typeof setInitialState === "function") {
  //       setInitialState((prev) => ({
  //         ...prev,
  //         voucherNumber,
  //         seriesVouchers: selectedOption,
  //       }));
  //     }
  //   } catch (error) {
  //     setBackdropOpen(false);
  //     console.log("getGeneralSettings error:", error);
  //   }
  // }
  async function getGeneralSettings() {
    try {
      const res = await API.graphql(
        graphqlOperation(listGeneralSetting, {
          entrytypecd: invoiceLabels.voucherType,
          financialyearid: getCompany.financialyearid,
        })
      );

      const rows = res?.data?.listGeneralSetting || [];
      if (rows.length === 0) {
        const empty = { label: '', value: '',serialflag:0 };
        setData((p) => ({ ...p, voucherNumber: '', seriesVouchers: empty }));
        setInitialState?.((p) => ({ ...p, voucherNumber: '', seriesVouchers: empty }));
        return;
      }
      const validRows = rows.filter((r) => r?.expiredtimestamp === 0);
      const nextInvNo = validRows[0]?.nextinvoicenumber ?? -1;
      // setGeneralSettingsFlag(nextInvNo);
      const activeVouchers = validRows.filter((r) => r?.serialisactive === 1);

      if (activeVouchers.length === 0 && !params?.id) {
        const empty = { label: '', value: '',serialflag:0 };
        setData((p) => ({ ...p, voucherNumber: '', seriesVouchers: empty }));
        setInitialState?.((p) => ({ ...p, voucherNumber: '', seriesVouchers: empty }));
        return;
      }

      const toLabel = (v) => `${v?.prefix ?? ''}${v?.nextinvoicenumber ?? ''}${v?.suffix ?? ''}`.trim();

      const serialOptions = activeVouchers.map((v) => ({
        label: toLabel(v),
        value: v.serialnumber,
        serialflag:v.serialflag
      }));
//       const serialOptions = activeVouchers.map((v) => {
//   const taxabilityOption = allTaxabilityOptions.find(t => t.value === v.taxability);

//   return {
//     label: toLabel(v),
//     value: v.serialnumber,
//     taxability: v.taxability,
//     taxabilityLabel: taxabilityOption?.label || "", // ✅ Safe lookup
//   };
// });


      setActiveVouchers(activeVouchers);
      setSerialNos(serialOptions);
      const defaultVoucher = activeVouchers.find(v => v.lastused === 1) || activeVouchers[0];
      //  activeVouchers[0];
      const defaultLabel = toLabel(defaultVoucher);
      const selectedOption = { label: defaultLabel, value: defaultVoucher?.serialnumber,serialflag:defaultVoucher?.serialflag };
      if (params?.id) {
        let editedVoucher = '';
        let editedSeriesVoucher = { label: '', value: '',serialflag:0 };
        const editId =
          Type === 'Sales' || Type === 'Pos'
            ? invoiceEntry?.invoicenumber
            : Type === 'Purchase'
            ? invoiceEntry?.vouchernumber
            : invoiceEntry?.crdrnotenumber;
             const editedserialflag =
          Type === 'Sales' || Type === 'Pos'
            ? invoiceEntry?.serialflag
            : 0;

        if (editId) {
          if (invoiceEntry?.serialnumber === '') {
            editedVoucher = editId;
            editedSeriesVoucher = { label: '', value: '',serialflag:0 };
          } else {
            editedVoucher = editId;
            editedSeriesVoucher = { label: editId, value: invoiceEntry?.serialnumber,serialflag:editedserialflag };
          }
         
          
          setData((p) => ({
            ...p,
            voucherNumber: editedVoucher !== '' ? editedVoucher : defaultLabel,
            seriesVouchers: editedSeriesVoucher.value ? editedSeriesVoucher : selectedOption,
          }));
          setInitialState?.((p) => ({
            ...p,
            voucherNumber: editedVoucher ?? defaultLabel,
            seriesVouchers: editedSeriesVoucher ?? selectedOption,
          }));
        }
      } else {
        setData((p) => ({
          ...p,
          voucherNumber: defaultLabel,
          seriesVouchers: selectedOption,
        }));
        setInitialState?.((p) => ({
          ...p,
          voucherNumber: defaultLabel,
          seriesVouchers: selectedOption,
        }));
      }
    } catch (error) {
      console.error('getGeneralSettings error:', error);
      setBackdropOpen(false);
    }
  }
  function handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
      if (required && e.target.value === '') {
        e.preventDefault();
        e.stopPropagation();
        setData((prev) => ({
          ...prev,
          [name]: '',
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: warMsg,
          },
        }));
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  function handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID, multiple) {
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';

    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
      if (multiple && e.key === 'Enter') {
        return; // Exit without moving focus to next field
      }

      if (required && e.target.value === '' && isAutocompleteOpen && !activeDescendantId) {
        e.preventDefault();
        e.stopPropagation();
        setData((prev) => ({
          ...prev,
          [name]: '',
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: warMsg,
          },
        }));
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
//  useEffect(() => {
//   if (invoiceEntry) {
//     if (invoiceEntry.serialnumber === "") {
//       setGeneralSettingsFlag(-1);
//     } else {
//       setGeneralSettingsFlag("");
//     }
//   }
// }, [invoiceEntry]);
 useEffect(() => {
  if (voucherFlag) {
    if (voucherFlag !== -1) {
      setGeneralSettingsFlag("");
    } else {
      setGeneralSettingsFlag(-1);
    }
  }
}, [voucherFlag]);

  useEffect(() => {
    getGeneralSettings();
  }, [voucherList]);
  return (
    <>
      {generalSettingsFlag !== -1 ? (
        <>
          <Grid item lg={2} xs={12} md={12} sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ flex: 2 }}>
              <Autocomplete
                disablePortal
                disabled={data?.partyName?.value === '' || (invoiceEntry?.isvouchereditable === 0 && invoiceEntry?.serialnumber !== '')}
                id="voucher"
                options={
                  params?.id ? serialNos?.filter((r) => r?.value  !== invoiceEntry?.serialnumber) : serialNos
                }
 getOptionLabel={(option) => option?.label || ""}
  renderOption={(props, option) => {
    let typeLabel = "";
    if (Type === "Sales" || Type === "Pos") {
      typeLabel = option?.serialflag === 1 ? "BOS Invoice" : "Tax Invoice";
      return (
        <li {...props}>
          {option.label}&nbsp;&nbsp;&nbsp;({typeLabel})
        </li>
      );
    }
    return <li {...props}>{option.label}</li>;
  }}




  PopperComponent={CustomPopper}
                disableClearable
                value={data.seriesVouchers}
                fullWidth
                isOptionEqualToValue={(option, value) => option?.value == value?.value}
                onChange={handleVoucherChange}
                onKeyDown={handleVoucherKeyDown}
                sx={{
                  '.css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                    paddingBottom: '5px',
                  },
                  '.MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                    paddingTop: '6px',
                    paddingBottom: '5px',
                    paddingLeft: '6px',
                    paddingRight: '6px',
                  },
                }}
                size="small"
                renderInput={(params) => (
                  <TextField
                    error={data.errorStatus.seriesVouchers === true ? true : false}
                    sx={{
                      '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                        padding: '8.5px 7px',
                      },
                      '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                        fontSize: '14px',
                      },
                      label: {
                        fontSize: '14px',
                      },
                      '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                        fontSize: '14px',
                      },
                      '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                        color: 'input.font',
                      },
                      '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                        borderColor: 'input.border',
                      },
                      '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                        color: 'input.font',
                      },
                      '.css-14qz1ij-MuiListItemText-root': {
                        margin: '0px',
                      },
                      '.MuiFormLabel-asterisk': {
                        color: 'danger.main',
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...params}
                    required={true}
                    label={invoiceLabels.voucherName}
                    // label="Invoice Number"
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
              />
              <Typography
                sx={{
                  marginTop: '2px',
                  marginLeft: '10px',
                  marginBottom: '0px',
                  fontSize: '11px', // endAdornment: (

                  color: 'danger.main',
                }}
              >
                {data?.errorFields.seriesVouchers}
              </Typography>
            </Box>
            {(!params?.id || invoiceEntry?.isvouchereditable === 1 || invoiceEntry?.serialnumber === '') && (
              <Box sx={{}}>
                <ToolTipComponent
                  title={Type === 'Sales' ? 'Invoice Number Settings' : 'Voucher Number Settings'}
                  placement="top"
                  tooltipContent={
                    <IconButton
                      tabIndex={-1}
                      onClick={() => {
                        setOpenSettingsModal(true);
                      }}
                    >
                      <SettingsIcon sx={{ color: '#808080' }} />
                    </IconButton>
                  }
                />
              </Box>
            )}
          </Grid>
        </>
      ) : (
        <>
          <Grid item lg={2} xs={12} md={12} sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ flex: 2 }}>
              <TextField
                error={data.errorStatus.voucherNumber == true ? true : false}
                disabled={
                  data?.partyName?.value === ''
                    ? // || (invoiceEntry?.isvouchereditable && invoiceEntry?.isvouchereditable === 0)
                      true
                    : false
                }
                required={true}
                id="voucher"
                name={invoiceLabels?.voucherValue}
                label={invoiceLabels?.voucherName}
                size="small"
                type="text"
                fullWidth
                value={data?.voucherNumber}
                onChange={handleVoucherInputChange}
                onKeyDown={handleVoucherInputKeyDown}
                sx={{
                  '.css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                    paddingBottom: '5px',
                  },
                  '.css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                    paddingTop: '6px',
                    paddingBottom: '5px',
                    paddingLeft: '6px',
                    paddingRight: '6px',
                  },
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: <LabelIcon value={data.voucherNumber} type="text" editMode={false} />,
                  inputProps: { maxLength: 16 },
                }}
              />
              <Typography
                sx={{
                  marginTop: '2px',
                  marginLeft: '10px',
                  marginBottom: '0px',
                  fontSize: '11px',
                  color: 'danger.main',
                }}
              >
                {data?.errorFields.voucherNumber}
              </Typography>
            </Box>
            {/* {(!params?.id || (invoiceEntry?.isvouchereditable && invoiceEntry?.isvouchereditable === 1)) && ( */}
            <Box sx={{}}>
              <ToolTipComponent
                title={Type === 'Sales' ? 'Invoice Number Settings' : 'Voucher Number Settings'}
                placement="top"
                tooltipContent={
                  <IconButton
                    onClick={() => {
                      setOpenSettingsModal(true);
                    }}
                  >
                    <SettingsIcon sx={{ color: '#808080' }} />
                  </IconButton>
                }
              />
            </Box>
            {/* )} */}
          </Grid>
        </>
      )}

      <NewVoucherSettingsModal
        open={openSettingsModal}
        label={Type}
        type={invoiceLabels.voucherType} //invoice label
        setOpen={setOpenSettingsModal}
      />
    </>
  );
}

export default VoucherComponent;
